export default __webpack_public_path__ + "static/media/x-infinity.c93735bc.jpg";